import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';
import { BaseServices } from './../../kuba.services';
import { UserService } from './../../users/services/user.service';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';


import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaderResponse } from '@angular/common/http';
import { Client, User } from '../models/client';
import { ClientContact } from '../models/clientContact';

@Injectable()
export class ClientServices {

    constructor(private http: HttpClient,
        private userService: UserService
        ) {
    }

    getAllClientsByBusiness() {
        return this.http.get<any[]>(environment.BASE_URL + '/client/getall/' + BaseServices.BusinessId, ).pipe(rxjsmap(result => (result) ? result : null!));
    }

    getAllClients() {
        return this.http.get<any[]>(environment.BASE_URL + '/client/list/' + BaseServices.BusinessId, ).pipe(rxjsmap(result => (result) ? result : null!));
    }

    getClientById(id: number) {
        return this.http.get<any>(environment.BASE_URL + '/client/getclientinfobyid/' + id, ).pipe(rxjsmap(result => result));
    }
    createClient(client:any) {

        return this.http.post(environment.BASE_URL + '/client/SaveAdditional', client, ).pipe(rxjsmap(result => result));
    }
    updateClient(client: Client) {
        return this.http.put(environment.BASE_URL + '/client/UpdateAdditional', client, ).pipe(rxjsmap(result => result));
    }
    deleteById(id: number) {
        return this.http.delete(environment.BASE_URL + '/client/client/' + id, )
            .toPromise()
            .then((response: any) => { return response });
    }
    getAllTypeOfclient() {
        return this.http.get(environment.BASE_URL + '/contacttypes/contactTypes', ).pipe(rxjsmap(result => result));
    }
    getContactType() {
        return this.http.get(environment.BASE_URL + '/contacttypes/contactTypes', ).pipe(rxjsmap(result => result));
    }
    getCountryCode() {
        return this.http.get<any>(environment.BASE_URL + '/countrycode/countrycodes', ).pipe(rxjsmap(result => result));
    }
    getClientContactByContactId(id: number) {
        return this.http.get<any>(environment.BASE_URL + '/clientcontact/clientcontactsbyContact/' + id, ).pipe(rxjsmap(result => result));
    }
    getClientContactById(id: number) {
        return this.http.get(environment.BASE_URL + '/clientcontact/clientcontacts/' + id, ).pipe(rxjsmap(result => result));
    }
    addClientContact(contact: ClientContact) {
        return this.http.post(environment.BASE_URL + '/clientcontact/clientcontact', contact, ).pipe(rxjsmap(result => result));
    }
    updateClientContact(contact: ClientContact) {
        return this.http.put(environment.BASE_URL + '/clientcontact/clientcontact', contact, ).pipe(rxjsmap(result => result));
    }
    deleteClientContact(id: number) {
        return this.http.delete(environment.BASE_URL + '/clientcontact/clientcontact/' + id, ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
    }
    statusUpdate(id: any, status: any) {
        return this.http.put(environment.BASE_URL + '/client/clients/' + id, status, ).pipe(rxjsmap(result => result));
    }
    deleteClient(ids: number[]) {
        return this.http.put(environment.BASE_URL + '/client/clients', ids, ).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
    }
    getClientContactUser(featureKey: number): Observable<User> {
        return this.http.get<any>(`${environment.BASE_URL}/clientcontact/clientcontactuser/${featureKey}`, ).pipe(rxjsmap(result => result));
    }

    addUser(data: User) {
        return this.http.post(environment.BASE_URL + '/user', data, ).pipe(rxjsmap(result => result));
    }
    updateUser(data:any) {
        return this.userService.updateUser(data.Id, data).pipe(rxjsmap(result => result));
    }
    getUserById(Id:any) {
        return this.userService.getUsersById(Id);
    }
    getModuleList(clientId:any) {
        return this.http.get<any>(environment.BASE_URL + '/client/clientmodule/' + clientId, ).pipe(rxjsmap(result => result));
    }
    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}
